import styled from "styled-components";
import {hexToRgba} from "../../../../../themes/hex-to-rgba";
import {SideMenuItemsListDefaultBox} from "./side-menu-items-list.default.box";

export const SideMenuItemsListCasino777Box = styled(SideMenuItemsListDefaultBox)`
    background-color: ${({theme}) => hexToRgba(theme.colors.background, 0.7) };
    box-shadow: 2px 3px 1rem rgba(25, 50, 48, 0.2);
`;
